import * as React from "react";
import { AnyAction, Dispatch } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../store";
import { showTaskModal } from "../../../store/modals/actions";
import { Task } from "../../../types";
import TasksSimplebar, { MyTasksSimplebar } from "../../Navigation/SidebarTask/TasksSimplebar";
import SimplebarWidgetContainer from "./SimplebarWidgetContainer";

const TasksWidget = () => {
  const dispatch = useDispatch() as Dispatch<AnyAction>;
  const currentUser = useSelector((state: AppState) => state.authentication.currentUser);
  const tasksSimplebar = React.useRef<MyTasksSimplebar>(null);

  const onTaskItemClick = (task: Task) => {
    dispatch(showTaskModal({ task: { id: task.id } }));
  };

  const onAddTaskClick = () => {
    dispatch(
      showTaskModal({
        task: {
          assignee_ids: [currentUser.id],
          assignees: [currentUser],
        },
        onSubmit: (task) => {
          tasksSimplebar.current?.fetchTasks(1);
          onTaskItemClick(task);
        },
        onDelete: () => {
          tasksSimplebar.current?.fetchTasks(1);
        },
      })
    );
  };

  return (
    <SimplebarWidgetContainer>
      <TasksSimplebar
        ref={tasksSimplebar}
        active={true}
        onItemClick={onTaskItemClick}
        onAddTaskClick={onAddTaskClick}
      />
    </SimplebarWidgetContainer>
  );
};

export default TasksWidget;
